module.exports = __webpack_public_path__ + "img/bbt-logo.b93a99ea.jpg";